import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _toConsumableArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";

var _templateObject, _templateObject2;

import { useMemo, useState } from 'react';
import styled from 'styled-components';
import { AlertDot } from '@yoweb/ui/components/indicators';
import { convertTimeProtoToTimestamp } from '@yoweb/utils/converters';
import { Box } from '@yoweb/ui/components/Box';
import { Title, Text, Interactive } from '@yoweb/ui/components/typography';
import { useTranslation } from '@yoweb/next-i18next';
import { th } from '@yoweb/ui/styles/utils/theme';
import { media } from '@yoweb/ui/styles/utils';
import { CaretDownThickIcon, CaretUpIcon } from '@yoweb/ui/components/Icon';
import Spinner from '@yoweb/ui/components/Spinner';
import { TaskActionCard } from '@poplar/components/Home/TaskActionCard';
import { EmptySection, GetStarted } from './TodosPageCommon';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { formatDate } from '@yoweb/utils/date';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var TodosPageLarge = function TodosPageLarge(_ref) {
  var showGettingStarted = _ref.showGettingStarted,
      dataCompleted = _ref.dataCompleted,
      dataInProgress = _ref.dataInProgress,
      dataDraft = _ref.dataDraft,
      dataUpcoming = _ref.dataUpcoming,
      sectionIndicators = _ref.sectionIndicators,
      isDeletingBookmark = _ref.isDeletingBookmark,
      openFeedbackFlyout = _ref.openFeedbackFlyout,
      onDeleteExpiredBookmark = _ref.onDeleteExpiredBookmark;

  var _useTranslation = useTranslation('tasks'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Box, {
    children: [/*#__PURE__*/_jsx(Title, {
      size: "lg",
      as: "h1",
      children: t('to-dos')
    }), showGettingStarted && /*#__PURE__*/_jsx(Box, {
      mt: "medium1",
      "data-testid": "task-section-getting-started",
      children: /*#__PURE__*/_jsx(GetStarted, {})
    }), /*#__PURE__*/_jsxs(Box, {
      mt: "medium1",
      display: "grid",
      gap: "normal1",
      "data-testid": "task-section-drafts-large",
      children: [/*#__PURE__*/_jsx(TitleWithIndicator, {
        text: t('to-do-states.draft'),
        hasIndicator: sectionIndicators.draft
      }), /*#__PURE__*/_jsx(TaskGrid, {
        tasksData: dataDraft,
        isDeletingBookmark: isDeletingBookmark,
        onDeleteExpiredBookmark: onDeleteExpiredBookmark,
        EmptySectionElement: /*#__PURE__*/_jsx(EmptySectionLarge, {
          testId: "drafts-empty",
          title: t('to-dos-page.drafts-empty.title'),
          text: t('to-dos-page.drafts-empty.text')
        })
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      mt: "medium1",
      display: "grid",
      gap: "normal1",
      "data-testid": "task-section-upcoming-large",
      children: [/*#__PURE__*/_jsx(TitleWithIndicator, {
        text: t('to-do-states.upcoming'),
        hasIndicator: sectionIndicators.upcoming
      }), /*#__PURE__*/_jsx(TaskGrid, {
        tasksData: dataUpcoming,
        isDeletingBookmark: isDeletingBookmark,
        onDeleteExpiredBookmark: onDeleteExpiredBookmark,
        EmptySectionElement: /*#__PURE__*/_jsx(EmptySectionLarge, {
          testId: "upcoming-empty",
          title: t('to-dos-page.upcoming-empty.title'),
          text: t('to-dos-page.upcoming-empty.text')
        })
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      mt: "medium1",
      display: "grid",
      gap: "normal1",
      "data-testid": "task-section-in-progress-large",
      children: [/*#__PURE__*/_jsx(TitleWithIndicator, {
        text: t('to-do-states.in-progress'),
        hasIndicator: sectionIndicators.inProgress
      }), /*#__PURE__*/_jsx(TaskGrid, {
        tasksData: dataInProgress,
        isDeletingBookmark: isDeletingBookmark,
        onDeleteExpiredBookmark: onDeleteExpiredBookmark,
        EmptySectionElement: /*#__PURE__*/_jsx(EmptySectionLarge, {
          testId: "in-progress-empty",
          title: t('to-dos-page.in-progress-empty.title'),
          text: t('to-dos-page.in-progress-empty.text')
        })
      })]
    }), /*#__PURE__*/_jsxs(Box, {
      mt: "medium1",
      display: "grid",
      gap: "normal1",
      "data-testid": "task-section-archived-large",
      children: [/*#__PURE__*/_jsx(TitleWithIndicator, {
        text: t('to-do-states.archived'),
        hasIndicator: sectionIndicators.completed
      }), /*#__PURE__*/_jsx(TaskGrid, {
        tasksData: dataCompleted,
        isGroupedMonthly: true,
        isDeletingBookmark: isDeletingBookmark,
        onDeleteExpiredBookmark: onDeleteExpiredBookmark,
        openFeedbackFlyout: openFeedbackFlyout,
        EmptySectionElement: /*#__PURE__*/_jsx(EmptySectionLarge, {
          testId: "archived-empty",
          title: t('to-dos-page.completed-empty.title'),
          text: t('to-dos-page.completed-empty.text')
        })
      })]
    })]
  });
};

var TitleWithIndicator = function TitleWithIndicator(_ref2) {
  var text = _ref2.text,
      hasIndicator = _ref2.hasIndicator;
  return /*#__PURE__*/_jsxs(Box, {
    display: "flex",
    gap: "small3",
    alignItems: "center",
    children: [hasIndicator && /*#__PURE__*/_jsx(AlertDot, {
      color: "critical"
    }), /*#__PURE__*/_jsx(Title, {
      as: "h2",
      size: "sm",
      children: text
    })]
  });
};

var EmptySectionLarge = function EmptySectionLarge(_ref3) {
  var testId = _ref3.testId,
      title = _ref3.title,
      text = _ref3.text;
  return /*#__PURE__*/_jsxs(EmptySection, {
    "data-testid": testId,
    children: [/*#__PURE__*/_jsx(Title, {
      size: "xs",
      children: title
    }), /*#__PURE__*/_jsx(Box, {
      mt: "small3",
      children: /*#__PURE__*/_jsx(Text, {
        children: text
      })
    })]
  });
};

var PAGE_SIZE = 15;
var TASK_COUNT_INITIAL = 3;

var TaskGrid = function TaskGrid(_ref4) {
  var tasksData = _ref4.tasksData,
      isGroupedMonthly = _ref4.isGroupedMonthly,
      isDeletingBookmark = _ref4.isDeletingBookmark,
      EmptySectionElement = _ref4.EmptySectionElement,
      onDeleteExpiredBookmark = _ref4.onDeleteExpiredBookmark,
      openFeedbackFlyout = _ref4.openFeedbackFlyout;

  var _useTranslation2 = useTranslation('tasks'),
      t = _useTranslation2.t;

  var _useIntlMeta = useIntlMeta(),
      locale = _useIntlMeta.locale;

  var _useState = useState(TASK_COUNT_INITIAL),
      showingCount = _useState[0],
      setShowingCount = _useState[1];

  var tasks = useMemo(function () {
    var _tasksData$data;

    var tasksAll = tasksData === null || tasksData === void 0 ? void 0 : (_tasksData$data = tasksData.data) === null || _tasksData$data === void 0 ? void 0 : _tasksData$data.reduce(function (acc, curr) {
      if (curr !== null && curr !== void 0 && curr.tasks) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(curr.tasks));
      }

      return acc;
    }, []);
    return tasksAll || [];
  }, [tasksData]);
  var nextPageToken = useMemo(function () {
    var _tasksData$data2;

    if (!(tasksData !== null && tasksData !== void 0 && tasksData.data)) return null;
    return (_tasksData$data2 = tasksData.data[tasksData.data.length - 1]) === null || _tasksData$data2 === void 0 ? void 0 : _tasksData$data2.encodedNextPageToken;
  }, [tasksData === null || tasksData === void 0 ? void 0 : tasksData.data]);
  var hasShowLess = !nextPageToken && tasks.length > 3 && showingCount >= tasks.length;
  var hasShowMore = tasks.length > showingCount || nextPageToken;

  var viewMore = function viewMore() {
    if (tasksData.isValidating) {
      return;
    }

    if (tasks.length > showingCount) {
      if (showingCount + PAGE_SIZE > tasks.length) {
        setShowingCount(tasks.length);
      } else {
        setShowingCount(showingCount + PAGE_SIZE);
      }
    } else {
      setShowingCount(showingCount + PAGE_SIZE);

      if (nextPageToken) {
        void tasksData.setSize(tasksData.size + 1);
      }
    }
  };

  var viewLess = function viewLess() {
    setShowingCount(TASK_COUNT_INITIAL);
  };

  var grouped = useMemo(function () {
    if (!isGroupedMonthly) {
      var tasksDisplayed = tasks.slice(0, showingCount);
      return [{
        groupName: '',
        tasks: tasksDisplayed
      }];
    }

    var count = 0;
    var groupedTasks = tasks.reduce(function (acc, task) {
      var _convertTimeProtoToTi;

      if (count >= showingCount) return acc;
      var date = new Date((_convertTimeProtoToTi = convertTimeProtoToTimestamp(task.updatedTimestamp)) !== null && _convertTimeProtoToTi !== void 0 ? _convertTimeProtoToTi : '');
      var groupName = formatDate(date, {
        preset: date.getFullYear() === new Date().getFullYear() ? 'monthOnly' : 'monthAndYear',
        locale: locale
      });
      var group = acc.find(function (target) {
        return target.groupName === groupName;
      });

      if (group) {
        group.tasks.push(task);
      } else {
        acc.push({
          groupName: groupName,
          tasks: [task]
        });
      }

      count++;
      return acc;
    }, []);
    return groupedTasks;
  }, [tasks, isGroupedMonthly, showingCount, locale]);

  if (tasks.length === 0) {
    if (tasksData.isLoading) {
      return /*#__PURE__*/_jsx(EmptySection, {
        children: /*#__PURE__*/_jsx(Spinner, {})
      });
    }

    if (EmptySectionElement) {
      return EmptySectionElement;
    }
  }

  return /*#__PURE__*/_jsxs(TaskGridMain, {
    children: [grouped.map(function (group) {
      return /*#__PURE__*/_jsxs(Box, {
        display: "grid",
        gap: "small4",
        children: [/*#__PURE__*/_jsx(Text, {
          size: "lg",
          weight: "bold",
          children: group.groupName
        }), /*#__PURE__*/_jsx(TaskGridLayout, {
          children: group.tasks.map(function (task) {
            return /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(TaskActionCard, {
                task: task,
                isDeletingBookmark: isDeletingBookmark,
                onDeleteExpiredBookmark: onDeleteExpiredBookmark,
                onFeedbackRating: function onFeedbackRating(rating) {
                  openFeedbackFlyout === null || openFeedbackFlyout === void 0 ? void 0 : openFeedbackFlyout({
                    taskId: task.taskId,
                    name: task.name,
                    updated: convertTimeProtoToTimestamp(task.updatedTimestamp),
                    taskIsRepeatable: task.isRepeatable,
                    taskIsRepeating: task.isRepeating
                  }, rating);
                }
              })
            }, task.taskId);
          })
        })]
      }, group.groupName);
    }), hasShowMore && /*#__PURE__*/_jsxs(MoreLessRow, {
      role: "button",
      tabIndex: 0,
      onClick: viewMore,
      onKeyDown: viewMore,
      "data-testid": "view-more-button",
      children: [/*#__PURE__*/_jsx(Line, {}), /*#__PURE__*/_jsx(Box, {
        display: "flex",
        gap: "small3",
        alignItems: "center",
        children: tasksData.isValidating ? /*#__PURE__*/_jsx(Spinner, {
          size: "md"
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Interactive, {
            size: "md",
            children: t('to-dos-page.view-more')
          }), ' ', /*#__PURE__*/_jsx(CaretDownThickIcon, {})]
        })
      }), /*#__PURE__*/_jsx(Line, {})]
    }), hasShowLess && /*#__PURE__*/_jsxs(MoreLessRow, {
      role: "button",
      tabIndex: 0,
      onClick: viewLess,
      onKeyDown: viewLess,
      "data-testid": "view-less-button",
      children: [/*#__PURE__*/_jsx(Line, {}), /*#__PURE__*/_jsxs(Box, {
        display: "flex",
        gap: "small3",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Interactive, {
          size: "md",
          children: t('to-dos-page.view-less')
        }), " ", /*#__PURE__*/_jsx(CaretUpIcon, {})]
      }), /*#__PURE__*/_jsx(Line, {})]
    })]
  });
};

var MoreLessRow = styled.div.withConfig({
  componentId: "sc-wzoelw-0"
})(["display:grid;gap:", ";grid-template-columns:1fr auto 1fr;align-items:center;cursor:pointer;"], th.getSpace('normal2'));
var Line = styled.div.withConfig({
  componentId: "sc-wzoelw-1"
})(["height:2px;background-color:", ";width:100%;"], th.getColor('sandMedium'));
var TaskGridMain = styled.div.withConfig({
  componentId: "sc-wzoelw-2"
})(["display:grid;grid-gap:", ";grid-template-columns:1fr;grid-template-rows:1fr max-content;"], th.getSpace('normal2'));
var TaskGridLayout = styled.div.withConfig({
  componentId: "sc-wzoelw-3"
})(["display:grid;grid-template-columns:1fr;grid-gap:", ";", " ", ""], th.getSpace('normal1'), media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      grid-template-columns: 1fr 1fr;\n    "]))), media.xl(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      grid-template-columns: 1fr 1fr 1fr;\n    "]))));
export { TodosPageLarge };